import { BaseApiClient } from '../client'

export class DevApi extends BaseApiClient {
  async runSeed() {
    return this.request<{ merchantId: string; campaignId: string }>('/api/dev/seed', {
      method: 'POST',
    })
  }
}
